import { API } from "../../config/axiosConfig";

export const getPosts = (params) => {
  return API.get("/posts", {
    params,withCredentials:true,
  });
};

export const togglePostPublish = ( postId) => {
  return API.patch(
    `/posts/${postId}/publish`,
    {},
    
  );
};
export const togglePostUnpublish = ( postId) => {
  return API.patch(
    `/posts/${postId}/unpublish`,{},
  );
};

export const deletePost = (postId) => {
  return API.delete(`/posts/${postId}`,);
};

export const createPost = ( token,formData) => {
  return API.post("/posts/create", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPostById = (token, postId) => {
  console.log("Getting post by ID:", postId);
  return API.get(`/posts/${postId}`, {
    postId,
    
  });
};
export const updatePostById = (postId, token, formData) => {
  return API.put(`/posts/${postId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const addComment = (postId, data, token) => {
  return API.post(`posts/${postId}/comments`, data);
};

export const deleteComment = (postId, commentId, token) => {
  return API.delete(`posts/${postId}/comments/${commentId}`, {

  });
};

export const editComment = (postId, commentId, value, token) => {
  return API.put(
    `posts/${postId}/comments/${commentId}`,
    {
      content: value,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
